/**
 * Csv Schema of OcorrenciaTracking
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {OcorrenciaTracking} from '@/model/resource/OcorrenciaTracking'

/* TODO: review generated schema */
export class CsvOcorrenciaTrackingSchema extends Schema {
  readonly name = 'CsvOcorrenciaTracking'

  readonly fieldSet: FieldSet<OcorrenciaTracking> = {
    idOcorrenciaTracking: schema => schema.model.idOcorrenciaTracking,
    carga: schema => schema.model.carga?.$id ?? null,
    tipoOcorrencia: schema => schema.model.tipoOcorrencia?.$id ?? null,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    dataOcorrencia: schema => Helper.datetime(schema.model.dataOcorrencia),
    descricao: schema => schema.model.descricao,
    idOcorrenciaExterna: schema => schema.model.idOcorrenciaExterna,
  }
}
